import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress noisy ResizeObserver errors in dev overlay.
const resizeObserverErrors = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
];

if (typeof window !== "undefined" && window.ResizeObserver) {
  const BaseResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends BaseResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const isResizeObserverError = (message = "") =>
  resizeObserverErrors.some((msg) => message.includes(msg));

const suppressResizeObserverOverlay = (event) => {
  const message = event?.message || event?.reason?.message || "";
  if (!isResizeObserverError(message)) {
    return false;
  }
  event.preventDefault?.();
  event.stopImmediatePropagation?.();
  return true;
};

window.addEventListener("error", suppressResizeObserverOverlay, true);
window.addEventListener("unhandledrejection", suppressResizeObserverOverlay, true);
window.onerror = (message) => {
  if (isResizeObserverError(String(message || ""))) {
    return true;
  }
  return false;
};

const originalConsoleError = console.error;
console.error = (...args) => {
  const message = typeof args[0] === "string" ? args[0] : "";
  if (resizeObserverErrors.some((msg) => message.includes(msg))) {
    return;
  }
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
